const dropComma = s => s.replace(/,\s*$/, '')

const throwError = function(c) {
    throw new SyntaxError(`Unexpected token '${c}', not valid JSON`)
}

class State {
    complete(s) {
        throw new Error('Not implemented')
    }

    parse(c) {
        throw new Error('Not implemented')
    }
}

class DictState extends State {
    complete(s) {
        const dropEntry = s => s.slice(0, this.#i)

        if (0 === this.#phase) {
            return s + '}'
        }
        else if (1 === this.#phase) {
            return dropComma(dropEntry(s)) + '}'
        }
        else if (2 === this.#phase) {
            if (/:\s*$/.test(s)) {
                return dropComma(dropEntry(s)) + '}'
            }
            else {
                return s + '}'
            }
        }
        else if (3 === this.#phase) {
            return dropComma(s) + '}'
        }
    }

    parse(c, i) {
        if (/\s/.test(c)) {
            return [this]
        }

        if (0 === this.#phase) {
            if ('"' === c) {
                this.#phase = 1
                this.#i = i
                return [this, new StringState]
            }

            if ('}' === c) {
                return []
            }
        }
        else if (1 === this.#phase) {
            if (':' === c) {
                this.#phase = 2
                return [this, new ValueState]
            }
        }
        else if (2 === this.#phase) {
            if (',' === c) {
                this.#phase = 3
                return [this]
            }

            if ('}' === c) {
                return []
            }
        }
        else if (3 === this.#phase) {
            if ('"' === c) {
                this.#phase = 1
                this.#i = i
                return [this, new StringState]
            }
        }

        throwError(c)
    }

    #i = -1
    #phase = 0
}

class FalseState extends State {
    complete(s) {
        return s + 'alse'.slice(this.#i)
    }

    parse(c) {
        if (0 === this.#i) {
            if ('a' === c) {
                this.#i += 1
                return [this]
            }
        }
        else if (1 === this.#i) {
            if ('l' === c) {
                this.#i += 1
                return [this]
            }
        }
        else if (2 === this.#i) {
            if ('s' === c) {
                this.#i += 1
                return [this]
            }
        }
        else if (3 === this.#i) {
            if ('e' === c) {
                return []
            }
        }

        throwError(c)
    }

    #i = 0
}

class ListState extends State {
    complete(s) {
        return dropComma(s) + ']'
    }

    parse(c) {
        if (/\s/.test(c)) {
            return [this]
        }

        if (0 === this.#phase) {
            if (']' === c) {
                return []
            }
            else {
                this.#phase = 1
                return [this, ...(new ValueState).parse(c)]
            }
        }
        else if (1 === this.#phase) {
            if (']' === c) {
                return []
            }
            else if (',' === c) {
                return [this, new ValueState]
            }
        }

        else {
            throwError(c)
        }
    }

    #phase = 0
}

class NullState extends State {
    complete(s) {
        return s + 'ull'.slice(this.#i)
    }

    parse(c) {
        if (0 === this.#i) {
            if ('u' === c) {
                this.#i += 1
                return [this]
            }
        }
        else if (1 === this.#i) {
            if ('l' === c) {
                this.#i += 1
                return [this]
            }
        }
        else if (2 === this.#i) {
            if ('l' === c) {
                return []
            }
        }

        throwError(c)
    }

    #i = 0
}

class NumberState extends State {
    complete(s) {
        return s.slice(0, - this.#s.length) +
            '-' === this.#s ? 0 : Number.parseFloat(this.#s)
    }

    parse(c) {
        this.#s += c

        if (
            '-' === this.#s ||
            /^-?(0|[1-9]\d*)\.$/.test(this.#s) ||
            /^-?(0|[1-9]\d*)(\.\d+)?[eE][+-]?$/.test(this.#s) ||
            /^-?(0|[1-9]\d*)(\.\d+)?([eE][+-]?\d+)?$/.test(this.#s)
        ) {
            return [this]
        }
        else {
            return c
        }
    }

    #s
}

class StringState extends State {
    complete(s) {
        return s + '"'
    }

    parse(c) {
        if (this.#esc) {
            this.#esc = false
            return [this]
        }
        else if ('\\' === c) {
            this.#esc = true
            return [this]
        }
        else if ('"' === c) {
            return []
        }
        else {
            return [this]
        }
    }

    #esc = false
}

class TrueState extends State {
    complete(s) {
        return s + 'rue'.slice(this.#i)
    }

    parse(c) {
        if (0 === this.#i) {
            if ('r' === c) {
                this.#i += 1
                return [this]
            }
        }
        else if (1 === this.#i) {
            if ('u' === c) {
                this.#i += 1
                return [this]
            }
        }
        else if (2 === this.#i) {
            if ('e' === c) {
                return []
            }
        }

        throwError(c)
    }

    #i = 0
}

class ValueState extends State {
    complete(s) {
        return s
    }

    parse(c) {
        if ('"' === c) {
            return [new StringState]
        }
        else if ('f' === c) {
            return [new FalseState]
        }
        else if ('n' === c) {
            return [new NullState]
        }
        else if ('t' === c) {
            return [new TrueState]
        }
        else if ('[' === c) {
            return [new ListState]
        }
        else if ('{' === c) {
            return [new DictState]
        }
        else if (/[-\d]/.test(c)) {
            return (new NumberState).parse(c)
        }
        else if (/\s/.test(c)) {
            return [this]
        }
        else {
            throwError(c)
        }
    }
}

export default class JSONStream {
    append(s) {
        const n = this.#s.length
        this.#s += s

        for (let i = 0; i < s.length; i += 1) {
            this.#parse(s[i], n + i)
        }

        let ss = this.#s

        for (const state of this.#states.toReversed()) {
            ss = state.complete(ss)
        }

        return ss
    }

    update(s) {
        if (s) {
            const d = s.slice(this.#s.length)
            return this.append(d)
        }
        else {
            throw new SyntaxError(`${s}' is not valid JSON`)
        }
    }

    #parse(c, i) {
        const state = this.#states.pop()

        if (! state) {
            throwError(c)
        }

        const x = state.parse(c, i)

        if (c === x) {
            this.#parse(c, i)
        }
        else {
            this.#states.push(...x)
        }
    }

    #s = ''
    #states = [new ValueState]
}
